module.exports = __webpack_public_path__ + "content/dam/oppo/coloros/img/img (203).7a00b3ac.jpg";